// Úvodné fotky – striedanie s prelínaním, pohyb (Ken Burns) rieši CSS – pozri _main-intro.scss
const INTRO_INTERVAL = 7000
const INTRO_FADE = 1800

// source (fotka na výšku) aj img – prehliadač si potom stiahne len tú, ktorá platí
function loadSlide( slide ) {
    if ( !slide ) return

    slide.querySelectorAll( "[data-srcset]" ).forEach( function( el ) {
        el.srcset = el.dataset.srcset
        el.removeAttribute( "data-srcset" )
    } )
}

function initIntroSlides() {
    const root = document.querySelector( "[data-intro-slides]" )

    if ( !root ) return

    const slides = root.querySelectorAll( ".main-intro--slide" )

    if ( slides.length < 2 ) return

    let current = 0
    let timer = null
    let inView = true

    // ďalšia fotka sa načíta vopred, aby bola pripravená na prelínanie
    loadSlide( slides[1] )

    function next() {
        const prev = slides[current]
        current = ( current + 1 ) % slides.length
        const slide = slides[current]

        slide.classList.add( "is-visible", "is-active" )
        prev.classList.remove( "is-active" )
        loadSlide( slides[( current + 1 ) % slides.length] )

        // pohyb predchádzajúcej fotky beží počas prelínania, potom sa resetuje
        setTimeout( function() {
            if ( !prev.classList.contains( "is-active" ) ) prev.classList.remove( "is-visible" )
        }, INTRO_FADE )
    }

    function start() {
        if ( !timer && inView && !document.hidden ) timer = setInterval( next, INTRO_INTERVAL )
    }

    function stop() {
        clearInterval( timer )
        timer = null
    }

    // mimo obrazovky alebo v skrytej karte sa nestrieda (šetrí výkon, CSS pohyb sa aj tak pozastaví)
    document.addEventListener( "visibilitychange", function() {
        document.hidden ? stop() : start()
    })

    if ( "IntersectionObserver" in window ) {
        new IntersectionObserver( function( entries ) {
            inView = entries[0].isIntersecting
            inView ? start() : stop()
        }).observe( root )
    }

    root.style.setProperty( "--intro-interval", INTRO_INTERVAL + "ms" )
    root.style.setProperty( "--intro-fade", INTRO_FADE + "ms" )
    start()
}

$(document).ready( function() {
    initIntroSlides()
})
